import { Home, Users, DollarSign, Server, UserCheck, Bookmark, AlertCircle, Settings, Archive, TrendingUp } from 'react-feather';
import { useSelector } from 'react-redux';

export const generateMenuItems = () => {
    const authState = useSelector((state) => state.auth);
    return [
        {
            menutitle: 'General',
            Items: [
                {
                    title: 'Dashboard', path: `${process.env.PUBLIC_URL}/dashboard`, icon: Home, type: 'link', active: false,
                },
                (authState.userRole === 1 ||
                    authState.permissions.includes('show-customer') ||
                    authState.permissions.includes('show-stb') ||
                    authState.permissions.includes('show-wallet')) &&
                ({

                    title: 'Customers', icon: Users, type: 'sub', active: false, children: [
                        (authState.userRole === 1 || authState.permissions.includes('show-customer')) && (
                            { path: `${process.env.PUBLIC_URL}/customers/customer`, title: 'Customer', type: 'link' }
                        ),
                        (authState.userRole === 1 || authState.permissions.includes('show-customer')) && (
                            { path: `${process.env.PUBLIC_URL}/customers/customer-archive`, title: 'Customer Archive', type: 'link' }
                        ),
                        (authState.userRole === 1 || authState.permissions.includes('show-stb')) && (
                            { path: `${process.env.PUBLIC_URL}/customers/bin`, title: 'Bin Account', type: 'link' }
                        ),
                        (authState.userRole === 1 || authState.permissions.includes('show-wallet')) && (
                            { path: `${process.env.PUBLIC_URL}/customers/wallet`, title: 'Wallet', type: 'link' }
                        ),
                        // (authState.userRole === 1 || authState.permissions.includes('show-customer')) && (
                        //     { path: `${process.env.PUBLIC_URL}/customers/customer-archive`, title: 'SMS', type: 'link' }
                        // ),
                    ]

                }),
                (authState.userRole === 1 ||
                    authState.permissions.includes('show-subscription') ||
                    authState.permissions.includes('show-order') ||
                    authState.permissions.includes('show-invoice-cancel') ||
                    authState.permissions.includes('recurring') ||
                    authState.permissions.includes('show-invoice')) &&
                ({
                    title: 'Billing', icon: DollarSign, type: 'sub', active: false, children: [
                        (authState.userRole === 1 || authState.permissions.includes('show-subscription')) && (
                            { path: `${process.env.PUBLIC_URL}/billing/subscription`, title: 'Subscription', type: 'link' }
                        ),
                        (authState.userRole === 1 || authState.permissions.includes('show-invoice')) && (
                            { path: `${process.env.PUBLIC_URL}/billing/invoice`, title: 'Invoice', type: 'link' }
                        ),
                        (authState.userRole === 1 || authState.permissions.includes('show-invoice-cancel')) && (
                            { path: `${process.env.PUBLIC_URL}/billing/invoice-cancel`, title: 'Cancelled Invoice', type: 'link' }
                        ),
                        (authState.userRole === 1 || authState.permissions.includes('show-order')) && (
                            { path: `${process.env.PUBLIC_URL}/billing/order`, title: 'Order', type: 'link' }
                        ),
                        (authState.userRole === 1 || authState.permissions.includes('recurring')) && (
                            { path: `${process.env.PUBLIC_URL}/billing/recurring`, title: 'Recurring', type: 'link' }
                        )
                    ]
                }),
                (authState.userRole === 1 ||
                    authState.permissions.includes('show-package') ||
                    authState.permissions.includes('show-add-on') ||
                    authState.permissions.includes('show-item')) &&
                ({
                    title: 'Services', icon: Server, type: 'sub', active: false, children: [
                        (authState.userRole === 1 || authState.permissions.includes('show-package')) && (
                            { path: `${process.env.PUBLIC_URL}/Services/plan`, title: 'Plans', type: 'link' }
                        ),
                    ]
                }),

                (authState.userRole === 1 ||
                    authState.permissions.includes('show-option') ||
                    authState.permissions.includes('show-attribute') ||
                    authState.permissions.includes('show-item')) &&
                ({
                    title: 'Products', icon: Server, type: 'sub', active: false, children: [
                        (authState.userRole === 1 || authState.permissions.includes('show-item')) && (
                            { path: `${process.env.PUBLIC_URL}/Products/item`, title: 'Items', type: 'link' }
                        ),
                        (authState.userRole === 1 || authState.permissions.includes('show-attribute')) && (
                            { path: `${process.env.PUBLIC_URL}/Products/attribute`, title: 'Attributes', type: 'link' }
                        ),
                        (authState.userRole === 1 || authState.permissions.includes('show-option')) && (
                            { path: `${process.env.PUBLIC_URL}/Products/option`, title: 'Options', type: 'link' }
                        )
                    ]
                }),
                (authState.userRole === 1 ||
                    authState.permissions.includes('show-expense') ||
                    authState.permissions.includes('show-income') ||
                    authState.permissions.includes('show-header') ||
                    authState.permissions.includes('show-vendor')) &&
                ({
                    title: 'Expenses', icon: TrendingUp, type: 'sub', active: false, children: [
                        (authState.userRole === 1 || authState.permissions.includes('show-expense')) && (
                            { path: `${process.env.PUBLIC_URL}/Expenses/Expenses`, title: 'Expense', type: 'link' }
                        ),
                        (authState.userRole === 1 || authState.permissions.includes('show-income')) && (
                            { path: `${process.env.PUBLIC_URL}/Expenses/Income`, title: 'Income', type: 'link' }
                        ),
                        (authState.userRole === 1 || authState.permissions.includes('show-header')) && (
                            { path: `${process.env.PUBLIC_URL}/Expenses/Header`, title: 'Header', type: 'link' }
                        ),
                        (authState.userRole === 1 || authState.permissions.includes('show-vendor')) && (
                            { path: `${process.env.PUBLIC_URL}/Expenses/Vendor`, title: 'Vendor', type: 'link' }
                        ),
                    ]
                }),

                (authState.userRole === 1 ||
                    authState.permissions.includes('show-account') ||
                    authState.permissions.includes('show-transaction')) &&
                ({
                    title: 'Banking', icon: Archive, type: 'sub', active: false, children: [
                        (authState.userRole === 1 || authState.permissions.includes('show-account')) && (
                            { path: `${process.env.PUBLIC_URL}/banking/account`, title: 'Account', type: 'link' }
                        ),
                        (authState.userRole === 1 || authState.permissions.includes('show-transaction')) && (
                            { path: `${process.env.PUBLIC_URL}/banking/transaction`, title: 'Transaction', type: 'link' }
                        ),
                    ]
                }),
                (authState.userRole === 1 ||
                    authState.permissions.includes('show-report')) &&
                    {
                        title: 'Reports', icon: Bookmark, type: 'sub', active: false, children: [
                            { path: `${process.env.PUBLIC_URL}/report/online-payment`, title: 'Online Payment', type: 'link' },
                            // { path: `${process.env.PUBLIC_URL}/report/customer-payment`, title: 'Customer Payment', type: 'link' },
                            { path: `${process.env.PUBLIC_URL}/report/bin-collection`, title: 'Bin Collection', type: 'link' },
                            { path: `${process.env.PUBLIC_URL}/report/bin-payment`, title: 'Bin Payment', type: 'link' },
                            { path: `${process.env.PUBLIC_URL}/report/bin-deactive`, title: 'Bin Deactive', type: 'link' },
                            { path: `${process.env.PUBLIC_URL}/report/payment-collection`, title: 'Payment Collection', type: 'link' },
                            // { path: `${process.env.PUBLIC_URL}/report/unpaid-customer`, title: 'Unpaid Customer', type: 'link' },
                            { path: `${process.env.PUBLIC_URL}/report/payment-due`, title: 'Payment Due', type: 'link' },
                            { path: `${process.env.PUBLIC_URL}/report/customer-summary`, title: 'Customer Summary', type: 'link' },
                            { path: `${process.env.PUBLIC_URL}/report/subscription-summary`, title: 'Subscription Summary', type: 'link' },
                            { path: `${process.env.PUBLIC_URL}/report/package-summary`, title: 'Plan Summary', type: 'link' },
                            { path: `${process.env.PUBLIC_URL}/report/order-summary`, title: 'Order Summary', type: 'link' },
                            { path: `${process.env.PUBLIC_URL}/report/agent-reward`, title: 'Agent Reward', type: 'link' },
                            { path: `${process.env.PUBLIC_URL}/report/reward-summary`, title: 'Reward Summary', type: 'link' },
                            { path: `${process.env.PUBLIC_URL}/report/reward-history-summary`, title: 'Reward History Summary', type: 'link' },
                            { path: `${process.env.PUBLIC_URL}/report/wallet-balance`, title: 'Wallet Balance', type: 'link' },
                            { path: `${process.env.PUBLIC_URL}/report/payment-gateway`, title: 'Payment Gateway', type: 'link' },
                            // { path: `${process.env.PUBLIC_URL}/report/income-vs-expence`, title: 'Income Vs Expense', type: 'link' },
                            // { path: `${process.env.PUBLIC_URL}/report/expense-summary`, title: 'Expense Summary', type: 'link' },
                            // { path: `${process.env.PUBLIC_URL}/report/income-summary`, title: 'Income Summary', type: 'link' },
                        ]
                    },

                (authState.userRole === 1 || authState.permissions.includes('show-complaint')) && (
                    { title: 'Request/Complaints', path: `${process.env.PUBLIC_URL}/complaints`, icon: AlertCircle, type: 'link' }
                ),

                authState.userRole === 1 &&
                {
                    title: 'Users', icon: UserCheck, type: 'sub', active: false, children: [
                        { path: `${process.env.PUBLIC_URL}/menu/user`, title: 'Users', type: 'link' },
                        { path: `${process.env.PUBLIC_URL}/menu/role`, title: 'Role', type: 'link' },
                    ]
                },

                (authState.userRole === 1 ||
                    authState.permissions.includes('show-area') ||
                    authState.permissions.includes('show-category')) &&
                (
                    {
                        title: 'Settings', icon: Settings, type: 'sub', active: false, children: [
                            // (authState.userRole === 1 || authState.permissions.includes('show-general')) && (
                            //     { path: `${process.env.PUBLIC_URL}/settings/general`, title: 'General', type: 'link' }
                            // ),
                            (authState.userRole === 1 || authState.permissions.includes('show-area')) && (
                                { path: `${process.env.PUBLIC_URL}/settings/area`, title: 'Area', type: 'link' }
                            ),
                            authState.userRole === 1 &&
                            { path: `${process.env.PUBLIC_URL}/settings/categories`, title: 'Categories', type: 'link' },
                            (authState.userRole === 1) && (
                                { path: `${process.env.PUBLIC_URL}/settings/payment`, title: 'Payment Method', type: 'link' }
                            ),
                            (authState.userRole === 1 || authState.permissions.includes('show-coupon')) && (
                            { path: `${process.env.PUBLIC_URL}/settings/coupon`, title: 'Coupon', type: 'link' }
                            ),
                            authState.userRole === 1 &&
                            { path: `${process.env.PUBLIC_URL}/settings/tax-group`, title: 'Tax', type: 'link' },
                            authState.userRole === 1 &&
                            { path: `${process.env.PUBLIC_URL}/settings/company-edit`, title: 'Company Details', type: 'link' },
                            (authState.userRole === 1 || authState.permissions.includes('edit-delivery')) && (
                            { path: `${process.env.PUBLIC_URL}/settings/delivery`, title: 'Delivery', type: 'link' }
                            ),
                            (authState.userRole === 1 || authState.permissions.includes('edit-reward')) && (
                            { path: `${process.env.PUBLIC_URL}/settings/reward`, title: 'Reward', type: 'link' }
                            ),
                        ]
                    }),
            ]
        },
    ]
}